'use client';

import { cn } from '@/lib/utils';
import { useRef, useEffect } from 'react';

export default function TrustBox({ lang }: { lang: string }) {
  const ref = useRef<HTMLDivElement | null>(null);

  const localeMap: Record<string, string> = {
    en: 'en-GB',
    it: 'it-IT',
    de: 'de-DE',
    fr: 'fr-FR',
  };

  useEffect(() => {
    const trustpilot = (window as any).Trustpilot;

    if (typeof window !== 'undefined' && trustpilot) {
      trustpilot.loadFromElement(ref.current, true);
    }
  }, [ref]);

  return (
    <div
      ref={ref}
      className={cn(
        'trustpilot-widget pt-4 pb-8 desktop:py-0 font-medium desktop:max-w-[230px]',
        {
          'desktop:max-w-[235px]': lang === 'de',
        },
      )}
      data-locale={localeMap[lang]}
      data-template-id="5419b637fa0340045cd0c936"
      data-businessunit-id="60f03f2970d674000116f325"
      data-style-height="20px"
      data-style-width="100%">
      <a
        href={`https://${lang === 'en' ? 'uk' : lang}.trustpilot.com/review/www.villatravellers.com`}
        target="_blank"
        rel="noopener"></a>
    </div>
  );
}
